import { useEffect, useState } from 'react'

/** Текущее время в миллисекундах, обновляется раз в `everyMs`: отсчёт блокировки кода и времени ожидания. */
export function useNow(everyMs: number, active = true): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!active) return undefined
    const timer = setInterval(() => setNow(Date.now()), everyMs)
    return () => clearInterval(timer)
  }, [active, everyMs])
  return now
}

/** «2:05» — сколько прошло с `startedAtIso`; будущее и непонятное время — «0:00». */
export function elapsedText(startedAtIso: string, now: number): string {
  const started = Date.parse(startedAtIso)
  const seconds = Number.isFinite(started) ? Math.max(0, Math.floor((now - started) / 1000)) : 0
  const minutes = Math.floor(seconds / 60)
  return `${minutes}:${String(seconds % 60).padStart(2, '0')}`
}

/** «Слишком много попыток, повторите через 5 мин»: сколько ждать, округляя минуты вверх. */
export function waitText(untilIso: string, now: number): string {
  const until = Date.parse(untilIso)
  const seconds = Number.isFinite(until) ? Math.max(0, Math.ceil((until - now) / 1000)) : 0
  if (seconds <= 60) return `${seconds} с`
  return `${Math.ceil(seconds / 60)} мин`
}
